const blogs = [
  {
    title : "Guideline For Newly Redux Learner", 
    publishedDate : "Aug 3, 2022" ,
    img: "https://i.ibb.co/hHBqL3k/redux-blog.jpg" , 
    placeholderImage : "https://i.ibb.co/W3g92cV/redux-blog-compressed.jpg" ,
    description : "From my experience of learning redux , I am sharing a guideline for newly redux learners. I hope my guideline will help you to gain redux knowledge without suffering any confusion." , 
    detailsLInk : "https://medium.com/@checkiamsiam/guideline-for-newly-redux-learner-49c6669213a5"
  }
]


export default blogs ;